/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/prefer-default-export */
import api from '@utils/axios';
import { apiInternalActivitiesPath } from '../../../routes';
import { ActivityPageSize, SorterOptions } from '../constants';
export const getActivities = ({ buildingId, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId, params }) => {
    const { type, sort, page } = params;
    return api.get(apiInternalActivitiesPath({
        building_id: buildingId,
        inspection_id: inspectionId,
        invoice_id: invoiceId,
        work_order_id: workOrderId,
        deficiency_id: deficiencyId,
        proposal_id: proposalId,
        format: 'json',
        filter: type.join(','),
        sort: sort === SorterOptions.NewestToOldest ? 'asc' : 'desc',
        select: {
            page,
            size: ActivityPageSize
        }
    }));
};
